import React from "react"
import { Link } from "gatsby"

import "./CookiesModal.scss"

class CookiesModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      acceptedCookies: true
    }

    this.cookies = this.cookies.bind(this)
  }
  componentDidMount() {
    let getCookie = p => {
      let c = document.cookie.split('; ')
      let f = c.find(el => el.split('=')[0] === p)

      return f ? f : false
    }

    if (getCookie('cookies_agree')) {
      this.setState({ acceptedCookies: true })
    }
    else {
      this.setState({ acceptedCookies: false })
    }
  }
  cookies() {
    document.cookie = `cookies_agree=true;max-age=${60 * 60 * 24 * 31}`
    this.setState({ acceptedCookies: true })
  }
  render() {
    let { acceptedCookies } = this.state
    return (
      acceptedCookies ? null : (
        <div className="cookies-modal">
          <div className="message">
            <p>
              Este sitio web utiliza cookies para brindarle la mejor experiencia.
              Al visitar este sitio, usted acepta la colocación de estas cookies.
              Para obtener más información, le recomendamos que lea nuestro <Link to="/terms">aviso de confidencialidad</Link>.
            </p>
          </div>
          <div>
            <button onClick={this.cookies}>De acuerdo</button>
          </div>
        </div>
      )
    )
  }
}

export default CookiesModal